import { colors } from '@alixpartners/ui-components';

import styled from 'styled-components';

export const Value = styled.div`
  font-weight: 500;
  font-size: 19px;
  line-height: 24px;
  color: ${colors.green600};
  margin-top: 8px;
  width: fit-content;

  &:hover {
    color: ${colors.green800};
    cursor: pointer;
  }

  a {
    color: ${colors.green600};
    border: 1px solid;
    border-color: ${colors.green700};
    width: fit-content;
  }
`;
